import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to succeed as a lead engineer – tactics and mindsets from practice",
  "description": "",
  "published": "2019-10-25T00:00:00.000Z",
  "redirect_from": ["/blog/how-to-be-lead-engineer-on-a-project-tactics-and-mindsets-from-practice/swizec/9222"],
  "categories": "Opinions, Personal",
  "hero": "./img/A47CSGG.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ca40418e09bca2a758261fa9f9c98ad4/e5166/A47CSGG.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.81614349775785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M183%2066c-4%205-2%2010%204%2013l5%204c2%202%202%202%203%201%200-2%200-3-2-4s-2-5%200-5l1-2c0-1%201-1%202%202%201%202%201%202%202%201%200-2-3-6-5-6l-3-3c-2-4-5-4-7-1m-16%2048c-5%208-6%2013-6%2024%201%208%200%2010-1%2010l-1%201-1-1-1-2-1%202c0%203%202%206%206%2012l3%207%202%206%206%204c7%203%2018%203%2022-1%202-3%204-2%204%202%201%202%201%201%201-2l1-8c0-4-1-5-2-3l-1%201v-2l2-2h-3a575%20575%200%2000-3%208c1%204-1%204-2%200%200-2-1-3-4-3l-9-3c-3-3-3-4%201-4%208-2%2011-5%204-5h-3l4-3%209-4c6-3%206-4-6-4-9%200-10%200-10%202s-3%205-6%205c-4-1-3-3%201-5s4-4%201-8c-3-3-4-5-4-14%200-11-1-13-3-10m166%206c-1%201%200%203%202%203l1%201c0%203%203%204%205%203%202-3%203-2%205%200l2%202%202-2c2-3%203-5%201-6v-1c1-1%200-1-3-1l-4%201c2%202-3%202-6%200-2-2-3-3-5%200m62-1h-2l-1%201%202%202c2%200%203%202%201%203l-4%205-3%204-2-3-2-2-4%202h-4l3%201%205%201c4%201%204%202%201%205l-3%204-4%207c-3%203-7%209-9%2014-5%207-7%2010-7%208%200-1-7-3-8-2-4%201-2%205%202%206l5%202-8%2017c-1%202-4%205-9%207-7%204-9%205-9%202%200-2-3-2-5%200s-2%202-4%201h-2c-1%201-22%201-23-1%200-1-1-1-3%201h-4c0-5-12-8-13-4-1%203-6%203-6%200s-6-3-7%200l2%201h4l-7%201c-6%201-6%201-4-1s2-2%201-4c-2-1-2-1-1-2%202-3-4-4-8-2s-4%203%200%203l2%201%201%201c3%200%203%204%201%205-3%202-3%201-3-1%201-3%201-3-1-2s-3%200-5-1l-5-2-2-2c0-3-4-3-5-1%200%202%200%202-3%201-3-2-10-8-12-12-2-3-3-3-5-2-1%201-1%202%202%206l3%205c-2%202-7%202-8%200l-4-1-3-1h-3l-2-1c-2-1-3%200-3%204v4h-6c-8%200-10-2-6-6%203-3-2-4-7-1l-2%202%202%202c3%202%202%204-1%204-2%200-3%203-2%207%200%204-1%204-4%201-2-2-4-2-6-2h-3l1-6-1-6-1%201c1%201%200%203-1%204s-1%201-1-1c1-3%201-3-2-3-4%200-14-2-16-4h-1l-3-2-11-8-3-3c-1-2-7-3-6%200%200%202-3%201-3-2-1-3-3-3-8-1-4%202-8%202-8-1l-3-2-4-3c0-2-2-3-2-1l-2%204-1%202-1-2-1-4%201-1c-1-1-7%201-10%203s-4%201-3-2c0-3-2-5-4-2h-6c-4%200-5%200-5%202l-2%202c-2%201-2%200-2-2%200-4-2-6-5-6-3%201-3%200-4-2-1-1-1-2-2-1l-2-1h-1c0%202-9%203-12%201-1-1-2%200-3%201-2%202-9%200-10-5h-3l-8%201-6%201v3c0%202%200%203%202%202l1%201-1%202c-2%200-2%202-2%2011%200%2010%201%2014%202%2010h2l-1%202c-3%202-4%208-1%2010v5c-2%200-2%205%200%205%202%201%204-2%203-4v-1l1-1v-1l2-1%202%201c2%202%202%202%200%202-3-1-5%200-2%201%202%201%201%205-1%207-2%201-2%202-1%204%200%202%201%202%201%201l3-1%202-2-1-1-1-1v-1l1-1v-1l1%201c0%202%203%201%204-3%202-3%202-4%204-3%202%200%202%200%200%202v1l2-1h1l1%202v2c-1%202%200%203%202%200%201-1%201-1%202%201h1c0-2%202-3%202-1l1%201%201-1%201-2c1%200%202%201%201%202v3l2-3c2-2%208-3%2010-2%201%200%201%201-1%201l-2%202h13c2%201%202%201%201%202l-1%202%202-1h7c2-2%201-2-1-4l-2-1h8l2-1-2%203c-3%202-3%203-3%206v3c-1%201%200%201%202%201h7l-1-1%201-2h2l1%204c0%202%203%200%203-3l2-1%201%202-1%201c-2%200-1%201%202%203h2v-4l-2-1c0-2%203-1%204%201l2%202%201-1c-1-2%201-2%204-1%201%201%202%202%201%203%200%201%202%202%203%200s5-1%205%201%201%202%203%202l3%201%204%201h5c1%202%206%201%206-1%201-2%203-2%203%200l2%203c4%202%204%202%200%201l-4%201%202%201v1l1%201h6c4%202%208%201%207%200h2l1-1v-1l3%203c1%203%201%203%202%202h1l3%204%202%202c-2%200-2%200-1%201s1%201-1%201-3%200-2-1l-2-1v-1c1-1%200-2-4-4-2-1-3-1-4%201%200%202-1%202-1%201%200-2-4%201-4%204%200%202%202%203%203%200l1-2v1l2%202%202%202-1%201c-1-1-2%200-2%201v2c0%201%207%202%209%201%201-1%201-1%201%201l1%201%202%201%203%201-1-2v-1l1-2c0-1%200-2%201-1l1-6c0-4%201-7%202-5%201%201%202%200%203-1h2c0%202%202%202%202%200s-4-6-6-5v-2h-1l-2%201%201-2v-2c-1-1%200-1%203-1%203%201%204%201%207%205%202%203%203%203%204%202%201-2%204%200%203%202h4c2%201%204-2%203-5l-1-3c1-1%204%202%204%204l1%201%201%201-2%201h-2l2%202%202%201c0%202%201%202%203%201%204-1%204%201%200%202l-2%203-4%205c-2%201-2%201%200%203l1%202%201%201%202-1-1-1v-2c-2%200-2-1-1-2h4c2%200%203%200%204%202s2%201%201-2c0-1-1-2-2-1l-1-1%203-1%202-1c0-3%202-2%202%200%201%201%201%200%201-1v-4l1%202c0%202%200%202%201%201h3c2%200%202%200%201%201v1l4-1v-2l-3-2c-5-4-6-4-11-5-6%200-6%200-4-2a3371%203371%200%20009%201l14%201%201-1%201%202c0%201%200%202%201%201v-1l1-1v-2c-1-1-1-1%201-1%204%201%206%200%203-4-2-3-3-4-1-7%201-2%201-2%203%201v4c0%202%204%206%207%206%203-1%204-2%200-3-4%200-6-2-4-4l2%201h3l2%201c0%202%205%206%209%207l6%202c4%201%206%201%205-1h-2c-1%200-2%200-2-2l3-1h3c2-2%203-1%203%201l2%204v2l-2%201%203%201c3-1%205-3%203-4l-2-2c-1-1-1-2%202-2l3%201%202%201c2%200%202%200%200-1l-1-2c1-2%205%203%205%205-1%202%200%202%201%202h1l2%201c2-1%203%201%201%201-1%201%200%201%201%202h6c-1-1%200-1%201-1v-1h-3l-2-1c-1-2%206-1%209%200v2c-3%200-3%202%200%202l4%201%204%202c4%200%204%200%203%202h-2l-1%203-2%202h3c1-2%207-2%207-1l1%201%203%201%205%202c3%200%204-1%203-2l-3-2v-2c2-1%202-1%203%201l3%201c1%200%203%203%202%204l5%201%206%201%202%201v1c-2%201-2%202-1%203l2-1c1-1%202-2%203-1v2l-2%201%201%201%201%201h-3l-2%201%205%201%205-1v-2l3%202c2%202%2044%202%2044-1a2165%202165%200%2000-1-40l-3-1-4-2-2%202c-1%201-4%202-4%200l2-1%201-1%202-2h5c3-1%203-1%203%201v2c2%200%203-6%201-12%200-3%200-3-4-3h-3c1-1-1-3-4-5l-5-5-1-1-2%202-2%203-3%203h-4c-5-1-5-1-5-5v-2l-3%203v3c1%202%201%203-3%204-2%201-2%201-3-1%200-1-1-2-2-1l-2-1-2-1c-1%200-1-1%201-3l3-4c1-2%204-3%204-1h1v-2l-2-2%205-10%202-3%201-4%202-5c1-2%202-5%204-6l2-4%207-10a255%20255%200%200016-20c2-2%202-4%202-7%200-5%200-5-1-4l-2%202-1-2h-1m-25%2054l1%201%201%203%201%204c2%201%201%205-1%205l-1%201-2%203c-2%202-2%205%200%203h13c4%200%205-1%205-3%200-1%200-2-2-3-1%200-2-1-1-2l-3-3c-3-1-3-1-3-4%201-4-5-8-8-5m-151%2022l1%202c1%201%201%201-1%203l-3%201h-3c0%203%208%203%2013%201l2%201c0%202%206%204%207%203v-2l-1-2-1-1-1-1-4-3-5-2h-4m-58%205c-2%204-5%205-7%202s-3-2-3%207c-1%207-1%209-3%209h-1v1l2%203c0%202%203%203%207%200%202%200%202%200%202%205l1%205v-1l1-2%201-9c1-7%202-9%203-9v-3l-1-2v2l-1-4c0-5-1-6-1-4m51%206c-1%202-2%202-5%201h-4l-1%204c0%203-1%204-2%205h-2l2%201c2%200%204%206%203%2010v2l1-2c1-2%201-2%204%200s4%202%206%201h5c2-2%202-3-1-2-1%200-3-6-1-7v-2c-2-1-2-3-3-6%200-6%200-7-2-5M1%20218v6l-1%201%202%201%201-1h1c1%201%200%202-1%203-2%201-3%205-1%204h4l1-1-2-1c-1%200-1-1%201-3s3-3%203-1h2l4-2%201-3c0-1%200-2%201-1l1%202%201-1c1-3-3-10-5-7h-2c-2%200-2%200-1%202H8l1%201v1l1%202%201%202-2-1H7l-1-3c0-2-1-3-3-4l-2-1v5m100%2010l1%201%204%204c0%201%204%202%207%201l3%201h12l1-1-5-7v4h-1l-1-1-1-1c0-1-2-2-10-2l-10%201m16%2010l1%202%201%201%201%202v2c-1%201%200%202%201%203v3c0%202%202%201%202-1l2-2%201-1%202-1%202%201%204%203c3%200%204-1%202-3h-1l-2%201-2-1c0-1%201-2%202-1l1-1c0-1-3-2-5-1l-1-1v-3c-2-1-3-1-3%201h-1l-3-2-3-1h-1m113%203l-2%202c1%201-2%202-5%201s-5%200-4%202l-2%201-2-2-1-1h-3c-3-1-4%200-3%202l2%201c2%201%203%203%201%203l-1-1h-3c-1-1-2%200-3%201s-3%202-5%201c-2%200-2%200-1%201%202%200%202%201%200%202l-3%201c-2-2-4-1-2%201%203%201%206%202%206%200-1-1%201-2%204-1%202%201%202%204%200%203l-1%201h-4c-1%201-1%201%201%202%202%202%209%203%209%202h3l1-1h5l1%202%201-1h2l1-1-2-1-3-2-1-2v2l-1%202v-1c0-2-1-2-3-2l-3-1h3l3-1v-1l2-1h1l2%201v-1l-2-3-1-1-1-1h6l2-1v-1l2-1h6l3-1-1%202-1%202h-4l2%202v1l-2-1-3-1c-2-1-2-1-1%202%200%203%200%203-2%202l1%202c1%202%203%203%203%202v-1c-2-2-1-3%202-3s3%201%203%203l1%202%201-2%201-3%201-2-2%201c-1%201-1%201-1-1l1-3%201-1%201%201c-1%201%202%205%203%205l-1-3-1-4%203-3h-5c-5%200-5%200-4-1%202-2%201-3-1-2m-218%205v1l-2%202-1%201c2%200%203%203%201%203l-1-1-1-1v2c2%203%201%203-1%202l-2-1-1%202v1l-1%201c-2%200-2%201%200%206%201%202%202%202%206%202h6c2-1%2011-2%2013-1l3-1%204-3h-1l-2-1%207-3h1v1l1%201%201-6c0-3-1-4-3-2l-1%203c1%202%200%202-1%201l-3-1c0-2-3-1-4%201l-3%201c-1-1-1-1%201-2v-2c-2%200-4%202-3%204%200%202%200%202-1%201-1-2-1-2-1%200s2%204%202%202h1c0%203-3%203-4%200-2-4-1-5%202-6v-2c-2-2-2-2-5%200h-3v-1l3-2v-2l-2%201-1%201-1-1c1-2-1-2-3-1m269%206c-2%202%200%203%206%204h8c3%201%202%203-1%203h-3c0%202-3%201-3-1h-2c-1%201-2%202-4%201l-2%201%204%201%205%201h1c3-2%208-1%2011%201%204%203%206%202%203-1l-2-1-1-1-2-4-1-2-1-1c1-1%200-2-2-2-3%200-3%200-2%201v1c-5%201-9%200-9-1h-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ca40418e09bca2a758261fa9f9c98ad4/ca0a1/A47CSGG.webp 223w", "/static/ca40418e09bca2a758261fa9f9c98ad4/75680/A47CSGG.webp 445w", "/static/ca40418e09bca2a758261fa9f9c98ad4/8d1ba/A47CSGG.webp 890w", "/static/ca40418e09bca2a758261fa9f9c98ad4/92f8c/A47CSGG.webp 1200w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ca40418e09bca2a758261fa9f9c98ad4/853b2/A47CSGG.jpg 223w", "/static/ca40418e09bca2a758261fa9f9c98ad4/0a4fe/A47CSGG.jpg 445w", "/static/ca40418e09bca2a758261fa9f9c98ad4/7f80b/A47CSGG.jpg 890w", "/static/ca40418e09bca2a758261fa9f9c98ad4/e5166/A47CSGG.jpg 1200w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/ca40418e09bca2a758261fa9f9c98ad4/7f80b/A47CSGG.jpg",
              "alt": "A47CSGG",
              "title": "A47CSGG",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You've just been handed a big project at work. It spans parts of the app you've never touched, tech you've never heard of, and it all needs to work together in one big unified feature.`}</p>
    <p>{`But fear not! Bob's gonna help with iOS, Kevin has Android, Stuart's doing backend, and you've got the webapp. You got dis! 💪`}</p>
    <p>{`Congratulations, you just became Lead Engineer on a project. You're nobody's boss and it's your fault when something goes wrong.`}</p>
    <p>{`Yes, `}<em parentName="p">{`your`}</em>{` fault. Not your team's, not your boss's, yours.`}</p>
    <p><a parentName="p" {...{
        "href": "https://echelonfront.com/extreme-ownership/"
      }}>{`Extreme Ownership`}</a>{` is a book you should read. Here's a TEDx recap from the author. Ignore the navy seal hardass delivery.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ljqra3BcqWM"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20113v112h401V0H0v113M228%203c-18%206-31%2026-32%2050-1%2014-3%2026-6%2030-2%204-3%2024-1%2025h1c0-2%202-3%2010-3%209%200%2010%201%2010%207%200%207%200%207-10%207-7%200-9%200-10-2-1-1-1-1-2%201-2%204%201%207%204%205%202-1%202-1%204%203l4%207%204%204v13c1%2012%201%2013-2%2016-3%204-3%206%200%203%203-4%204-3%205%2014l1%2013%206%206%206%205%2024-13c4-2%2014-12%2022-22%2015-19%2025-29%2023-24l5-1c7-4%207-4%206-6s-3-3-5%200l-2%201c-2%200-3-9-3-19s-2-13-3-6c-1%202-2%201-1-2%200-2-2-1-2%201l-7%2019c-2%202-2%204-2%206v1l-2%202-1%202-7%205-8%207c-3%202-16%203-17%201l-10-3-8-2a1254%201254%200%2000-7-14c-2-3%202-7%205-7l5-2c3-2%206-3%207-1s5%201%208-1l5-2%203-2c1-1%201-1%204%201s6%200%209-5c1-2%202-3%204-3l7-4%203-1c2-1%203-1%203-6%201-7%200-10-2-8h-2c0-2%200-2-1-1h-1l-1-1c-3%200-1-7%202-9%202-1%202-2%201-4%200-3%200-3%202-3%202%201%202%201%202-2l-1-7-2-7v-6l-2%203-2%202-2-3-2-3-1%202v4l-2%202c-1%202-2%202-7%200l-7-1c-1%201-5%200-6-2-1-1-1-1-3%201h-3c-3-2-4-1-4%201%200%203-1%203-3%201l-2-4-1-3c-1-1%200-3%202-3l1-1c0-3%2018-5%2021-2%201%201%201%201-6%203l-5%201%207%201%209%203c3%202%205%201%205-2-1-2%200-3%203-4l3-4%202-3%201-2c-1-1%208-5%2010-4h4l2%202%203%203%202%204c3%204%202%2013-1%2013l-1%201%202%201%201%204c0%205-2%207-5%205-3%200-6%204-6%207v5c-1%203-2%2014%200%2015l2%204c1%205%204%206%2010%201l12-17c0-4-4-12-7-14l-3-1V57l1-17-4-8c-4-9-14-18-26-23l-6-3c-5-5-24-6-33-3m-6%2078l-3%203%202%201c3%203%2017%203%2018%200l-1-3h-2c0%203-1%202-3%200l-3-2-4-1-4%202m69-1l-2%203-2%201c-2-1-2%200%200%206%200%202%200%204-2%205l-1%203v4c0%203%202%203%202%200l2-3c4%200%206-9%203-12s-2-3%202-3c6%201%209-1%207-4h-9m-67%2016c-2%201-4%202-9%202-2%200-5%202-5%204l11%201%2016%201c8%202%206-1-2-5-7-4-9-4-11-3m80%2058l2%202%201%203c-2%207-2%207%201%207l3-1c1-2%202-1%201%202l1%202%203%201%204%202c2-1%201%201%200%202l-2%204c-2%206-3%207-7%206-4-2-5-2-2%201%204%203%204%206%201%206-3%201-4%200-2-1%201-2-2-4-4-2l-3%201c-1%200-2%201-1%203l-1%204c-2%202%200%203%205%202h11c7%200%207%200%206-1-2-3%202-2%205%200l4%202v1l1%201h2l1%201%204%202%2010%202%2012-4c6-3%2012-4%207-1-3%201-3%201-1%202l10%206c2%202%203%201%201-2-2-5%200-5%203-1%202%203%204%204%205%204%202-1%204%201%203%203l2%202%201%201c0%202%202%204%203%203%202-2%201-6-2-8-3-1-3-2-3-4%201-2%200-2-4-4l-7-4c-2-2-3-2-4-1l-1%201v-1c1-2%200-2-7-5l-15-9c-8-8-15-12-27-18l-11-6a359%20359%200%2001-9-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/532dde8628291738e66fec866edbe3eb/ca0a1/techletter.app-screenshot-1572027740130.webp 223w", "/static/532dde8628291738e66fec866edbe3eb/75680/techletter.app-screenshot-1572027740130.webp 445w", "/static/532dde8628291738e66fec866edbe3eb/0ba47/techletter.app-screenshot-1572027740130.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/532dde8628291738e66fec866edbe3eb/e92b6/techletter.app-screenshot-1572027740130.png 223w", "/static/532dde8628291738e66fec866edbe3eb/e66bf/techletter.app-screenshot-1572027740130.png 445w", "/static/532dde8628291738e66fec866edbe3eb/6af66/techletter.app-screenshot-1572027740130.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/532dde8628291738e66fec866edbe3eb/6af66/techletter.app-screenshot-1572027740130.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I've been leading projects more and more this year as our team grows and the folks with "manager" in their title become too busy. It's been both empowering and frustratingly humbling.`}</p>
    <p>{`My last project was so smooth I think I finally figured out how to lead well. Here's what I've learned 👇`}</p>
    <h2 {...{
      "id": "how-to-succeed-as-a-lead-engineer"
    }}>{`How to succeed as a lead engineer`}</h2>
    <p>{`As lead engineer you are straddling the line between management and engineering. Your job is to do your work, write your code, oh and also you're responsible for the whole project and everybody else's work. Good luck.`}</p>
    <p>{`You often have no power – you don't choose your team, you don't hire anyone, you don't pick what to work on ... `}<strong parentName="p">{`you manage the project, not the people.`}</strong></p>
    <p>{`Ever noticed how there's no project managers in Silicon Valley? This is why. `}<em parentName="p">{`Engineers are project managers.`}</em></p>
    <p>{`Because you're lead `}<em parentName="p">{`engineer`}</em>{` your main work is still writing the code. You are expected to focus on implementing the feature, making tests pass, getting through code review.`}</p>
    <p>{`Managing the project is just tacked on top. It won't show up in your sprint, time will not be allotted. You just gotta find it.`}</p>
    <p>{`But come review time all your manager is going to ask, or know, is `}<em parentName="p">{`"Was that project successful?"`}</em></p>
    <p><img parentName="p" {...{
        "src": "/0ddd0d820a16e14940b529c1b78e7bb9/media-8OSf1vXgE3M1h3dlOG-giphy-downsized-medium.gif",
        "alt": "just_dont_fail giphy"
      }}></img></p>
    <p>{`Doesn't matter if you wrote the best code of your life and everyone else produced crap, or you wrote shit code and managed everyone else to excellence. Project failed.`}</p>
    <p><strong parentName="p">{`Your objective is a successful project`}</strong></p>
    <p>{`Make sure you check with your boss to know what that means. `}<em parentName="p">{`"What does success look like?"`}</em>{` is the most important question in your arsenal when starting any project.`}</p>
    <h2 {...{
      "id": "its-a-shift-in-mindset"
    }}>{`It's a shift in mindset`}</h2>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/vranac/status/1187784205952045056"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'302\\'%20viewBox=\\'0%200%20400%20302\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M39%2011c0%202%200%203-2%203s-4%202-4%205c0%201-1%202-4%202h-4c-1%201%200%208%202%208%201%200%203%202%202%204-1%203%2011%205%2017%202s9-10%205-10c-2%200-3-1-3-2l-2-2c-2%200-2%201-2%202v2l-1-4-2-5v-5l-1-4-1%204m52%20232c-2%202-3%203-3%205%200%204%202%207%203%205l4-1c2%200%202-1%202-3%200-1%200-2%201-1l1%202c-1%201%202%202%203%201%202-1%201-5-1-8-3-3-7-3-10%200m35%200c-4%205-2%2013%203%2011%202%200%202%200%201%201h6c1-1%201-1-1-2-1-2-1-2%201-3%202%200%203-2%203-3%200-2-5-6-7-6l-6%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/43ab119f5132e6c5bc3d8cdf23b1f6b2/ca0a1/techletter.app-screenshot-1572027737150.webp 223w", "/static/43ab119f5132e6c5bc3d8cdf23b1f6b2/75680/techletter.app-screenshot-1572027737150.webp 445w", "/static/43ab119f5132e6c5bc3d8cdf23b1f6b2/0ba47/techletter.app-screenshot-1572027737150.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/43ab119f5132e6c5bc3d8cdf23b1f6b2/e92b6/techletter.app-screenshot-1572027737150.png 223w", "/static/43ab119f5132e6c5bc3d8cdf23b1f6b2/e66bf/techletter.app-screenshot-1572027737150.png 445w", "/static/43ab119f5132e6c5bc3d8cdf23b1f6b2/6af66/techletter.app-screenshot-1572027737150.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/43ab119f5132e6c5bc3d8cdf23b1f6b2/6af66/techletter.app-screenshot-1572027737150.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Once you realize your goal is a successful project, not great code, everything changes. What can `}<em parentName="p">{`you`}</em>{` do to make this smoother?`}</p>
    <p>{`Your role is that of a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Force_multiplication"
      }}>{`force multiplier`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`In military science, force multiplication or a force multiplier refers to a factor or a combination of factors that gives personnel the ability to accomplish greater things than without it.`}</p>
    </blockquote>
    <p>{`What can `}<em parentName="p">{`you`}</em>{` do to make everyone else better?`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1177311199655915520"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "101.34529147982063%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'405\\'%20viewBox=\\'0%200%20400%20405\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-4%202-7%207-7%2011%200%205%201%209%203%209l1%202c-1%202%207%206%2011%206%203%200%2011-4%2011-5l-3-1c-3%200-4-3-1-5l3-1%203-2c2-2%202-2%201-6l-3-5-4-3c-3-3-10-3-15%200m31%2046v6h3c3%200%206-3%205-5v-4c0-3-1-4-5-4-3%200-3%200-3%207m128%20287c-6%202-6%2010%200%2013s13-4%2010-9c-2-3-7-5-10-4m19%201l-2%203-2%202v3c1%204%2012%204%2013%200%203-6-5-13-9-8m15%201c-3%203-2%207%201%2010%207%206%2016-4%209-11-3-3-6-3-10%201m18-1l-2%206c0%206%209%209%2013%205%207-7-4-17-11-11m38-1v4c-1%201%202%207%205%2010l2-2%202-1%202-2c2-3-3-10-7-10l-4%201m35%201c-3%203-3%205%200%206%202%200%203%201%201%203-1%201-1%201%201%202%207%206%2015-4%209-10-4-4-7-4-11-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d994e2d929aedc6ac5f1c8074c9b4e25/ca0a1/techletter.app-screenshot-1572027737202.webp 223w", "/static/d994e2d929aedc6ac5f1c8074c9b4e25/75680/techletter.app-screenshot-1572027737202.webp 445w", "/static/d994e2d929aedc6ac5f1c8074c9b4e25/0ba47/techletter.app-screenshot-1572027737202.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d994e2d929aedc6ac5f1c8074c9b4e25/e92b6/techletter.app-screenshot-1572027737202.png 223w", "/static/d994e2d929aedc6ac5f1c8074c9b4e25/e66bf/techletter.app-screenshot-1572027737202.png 445w", "/static/d994e2d929aedc6ac5f1c8074c9b4e25/6af66/techletter.app-screenshot-1572027737202.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d994e2d929aedc6ac5f1c8074c9b4e25/6af66/techletter.app-screenshot-1572027737202.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The best way to become a 10x engineer is to find 10 engineers and make them 2x. That's your role as lead. Making your team kickass.`}</p>
    <p>{`Your team is likely smaller so maybe aim for 5x? 😛`}</p>
    <p>{`What this means is that you will have to deprioritize your own work in favor of everybody else's work. Somebody blocked? Help them. Decision needs to be made? Help. Code review waiting for ya? Do it now, not later. Stuff needs to go into QA? Do it.`}</p>
    <p><strong parentName="p">{`Your job is to take on the crap work nobody else wants to do.`}</strong></p>
    <p>{`That means organizing discussions, keeping everyone in sync, dealing with QA, getting product signoff, organizing deployment, carrying that project over the finish line no matter what. All the stuff that makes you groan and wish you were writing code.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Avodovnik/status/1187753343789289474"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "85.65022421524664%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'342\\'%20viewBox=\\'0%200%20400%20342\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M40%209l-2%201-4%201h-2c-1-2-3%200-3%202s-1%203-2%203c-2%201-3%206-2%2010%203%2013%2022%2015%2027%202%202-5%202-11-1-10l-1-3-1-3c-1-1-1%201-1%204l-1%201-1-4-1-4h-5m51%20274c-6%204-3%2013%204%2013l3-1%202-1c2-1%203-4%201-4l-1-2h1c0%202%202%201%202-1s-5-6-7-6l-5%202m35%200l-2%206c0%206%209%209%2013%205%207-7-4-17-11-11m40-1c-6%202-5%2014%202%2014%205%200%207-8%203-13-2-2-3-2-5-1m15%201c-5%206-1%2013%205%2010h1l-2%202c-2%201-2%201%201%201%204%200%207-2%204-3-2%200-1-2%202-3s3-3-1-7c-3-3-7-3-10%200m20-1c-7%204-5%2013%204%2013%205%200%208-3%206-8v-2l-1%203-1%204v-4c1-6-2-8-8-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/20c4d900448806819d967f7b4b95b724/ca0a1/techletter.app-screenshot-1572027737266.webp 223w", "/static/20c4d900448806819d967f7b4b95b724/75680/techletter.app-screenshot-1572027737266.webp 445w", "/static/20c4d900448806819d967f7b4b95b724/0ba47/techletter.app-screenshot-1572027737266.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/20c4d900448806819d967f7b4b95b724/e92b6/techletter.app-screenshot-1572027737266.png 223w", "/static/20c4d900448806819d967f7b4b95b724/e66bf/techletter.app-screenshot-1572027737266.png 445w", "/static/20c4d900448806819d967f7b4b95b724/6af66/techletter.app-screenshot-1572027737266.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/20c4d900448806819d967f7b4b95b724/6af66/techletter.app-screenshot-1572027737266.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "so-what-do-you-do"
    }}>{`So what do you `}<em parentName="h2">{`do`}</em></h2>
    <p>{`Mindsets and objectives are nice, but what do you `}<em parentName="p">{`do`}</em>{`? We're engineers, we like details.`}</p>
    <p>{`You can read this section as an SOP – standard operating procedure. It's what I've found works for me and something I hope others on my team use as a guideline. Hi Pru 👋`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/mjsarfatti/status/1187751598610665478"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50.224215246636774%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'201\\'%20viewBox=\\'0%200%20400%20201\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M43%2021l-1%201c-3%200-4%200-3%201l1%203c0%202%200%202-2%201-2-3-2-3-1%203%201%202%202%205%201%206h4c6-1%2010-5%208-8v-1h3l-3-1c-4%200-4%200-4-3l-1-3-2%201m29%20122c-5%205-3%2012%203%2010%202%200%202%200%201%201-2%201-2%201%200%201%202%201%206-1%206-2l-1-1c-2%200-1-2%202-3s3-3-1-6c-4-4-6-4-10%200m22-1l-3%205-1%204c-4%202%204%205%208%203%202%200%203-1%203-2v-1l1-4c0-2%200-3-2-2l-2-1%202-1h1l-3-2c-3-1-2-1-4%201m18%200l-3%202-2%202%202%201c1%202%201%202-1%201-2%200-2%200-1%203%204%207%2015%204%2014-4-1-6-6-8-9-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c9bb6d5a65ce75a3dbe6380ad17c0c17/ca0a1/techletter.app-screenshot-1572027737093.webp 223w", "/static/c9bb6d5a65ce75a3dbe6380ad17c0c17/75680/techletter.app-screenshot-1572027737093.webp 445w", "/static/c9bb6d5a65ce75a3dbe6380ad17c0c17/0ba47/techletter.app-screenshot-1572027737093.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c9bb6d5a65ce75a3dbe6380ad17c0c17/e92b6/techletter.app-screenshot-1572027737093.png 223w", "/static/c9bb6d5a65ce75a3dbe6380ad17c0c17/e66bf/techletter.app-screenshot-1572027737093.png 445w", "/static/c9bb6d5a65ce75a3dbe6380ad17c0c17/6af66/techletter.app-screenshot-1572027737093.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c9bb6d5a65ce75a3dbe6380ad17c0c17/6af66/techletter.app-screenshot-1572027737093.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h3 {...{
      "id": "create-a-slack-channel"
    }}>{`Create a Slack channel`}</h3>
    <p>{`Or email thread, or whatever your team uses for communication. You need a central place for everything to do with a specific project. All async communication goes there. All in-person communication gets a recap there.`}</p>
    <p>{`This will be invaluable later on when something goes wrong and you want to see what the fuck happened. `}<em parentName="p">{`If you didn't write it down, it didn't happen.`}</em></p>
    <p>{`Humans forget everything.`}</p>
    <h3 {...{
      "id": "keep-a-checklist"
    }}>{`Keep a checklist`}</h3>
    <p>{`Ask your team to break down their part of the project as much as they can. You can attach estimates to each line or not. I personally find them useless but my bosses love seeing those imaginary numbers. 🤷‍♀️`}</p>
    <p>{`Add a checkbox next to each line. When a task gets done. Check it off.`}</p>
    <p>{`This creates an overview at a glance for all stakeholders. Someone wonders how the project is doing, how close to completion y'all are 👉 check the checklist.`}</p>
    <p>{`Your boss will ask you less often how it's going because they're already gonna know.`}</p>
    <h3 {...{
      "id": "daily-standup"
    }}>{`Daily standup`}</h3>
    <p>{`Create a daily standup. In person if that's your culture, over video, if you're remote.`}</p>
    <p>{`This is a quick sync up, 5 minutes or less. Chat about the project, discuss any issues, get an update on how everyone's doing. Build a team spirit. We're all in this together and we all want the project to succeed.`}</p>
    <p>{`There is no judgement, no guilt, only facts.`}</p>
    <p>{`Some management theories say standups are about making people feel guilty for not being as productive as their peers so they'll work harder. That shit is bullshit.`}</p>
    <h3 {...{
      "id": "post-a-standup-recap"
    }}>{`Post a standup recap`}</h3>
    <p>{`Only those actively working on the project `}<em parentName="p">{`today`}</em>{` should participate in your standup.`}</p>
    <p>{`The smaller the standup, the faster it's gonna go. You don't need everyone there in person. Sometimes they just need to know when they can start working on their part.`}</p>
    <p>{`Don't waste people's time.`}</p>
    <p>{`Instead, after standup, write a short recap summarizing the project status. Post it in the common communication area you created earlier.`}</p>
    <p>{`To quote my wonderful PM:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "696px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8db3429d44f8e0b7559a09a53bb38101/82158/MPQs9B0.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.390134529147986%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'125\\'%20viewBox=\\'0%200%20400%20125\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2021c-4%202-5%206-4%2021%200%2011%200%2012%202%2012s2%200%202-4v-5c1%200%201-2-1-4-3-5%201-14%206-14l3%203c3%204%204%204%204-1-1-7-6-10-12-8m-1%2061c-3%202-4%207-3%2020%200%2011%200%2012%202%2012s2-1%202-4v-8c-3-4-2-8%200-12s6-4%208-1l2%203c2%201%202%201%202-3-1-7-8-11-13-7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/8db3429d44f8e0b7559a09a53bb38101/ca0a1/MPQs9B0.webp 223w", "/static/8db3429d44f8e0b7559a09a53bb38101/75680/MPQs9B0.webp 445w", "/static/8db3429d44f8e0b7559a09a53bb38101/038cb/MPQs9B0.webp 696w"],
              "sizes": "(max-width: 696px) 100vw, 696px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/8db3429d44f8e0b7559a09a53bb38101/e92b6/MPQs9B0.png 223w", "/static/8db3429d44f8e0b7559a09a53bb38101/e66bf/MPQs9B0.png 445w", "/static/8db3429d44f8e0b7559a09a53bb38101/82158/MPQs9B0.png 696w"],
              "sizes": "(max-width: 696px) 100vw, 696px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/8db3429d44f8e0b7559a09a53bb38101/82158/MPQs9B0.png",
              "alt": "MPQs9B0",
              "title": "MPQs9B0",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`That's the goal right there.`}</p>
    <p><strong parentName="p">{`Added bonus: your boss won't bug you for updates. They can read the standup recap`}</strong></p>
    <p>{`I like to split the recap by person for accountability. Stuart did so and so, Kevin got this far, Bob was stolen from us by a production issue.`}</p>
    <h3 {...{
      "id": "delegate"
    }}>{`Delegate`}</h3>
    <p>{`This is your new super power. As lead, you get to delegate.`}</p>
    <p>{`Delegating is hard. It means letting go of your babies, letting others play with your legos, and stepping away from some of the work.`}</p>
    <p>{`But it's okay, they're great engineers and they're gonna do it even better than you could have.`}</p>
    <p>{`You're delegating everything you `}<em parentName="p">{`can't`}</em>{` do. Those parts of the feature you aren't owning anyway. Your job there is to provide clarity, help with organization, and hope for the best.`}</p>
    <p>{`But you should also delegate some of the things you `}<em parentName="p">{`can`}</em>{` do. Because others can do them better.`}</p>
    <p>{`Coming up with examples is tricky, you'll know it when you see it :)`}</p>
    <h3 {...{
      "id": "communicate-like-a-boss"
    }}>{`Communicate like a boss`}</h3>
    <p>{`This is more general advice but I like it a lot. A few turn-of-phrase hacks you can use to make everything flow smoother.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "640px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7cd4edb89f6d04b3df2ac7123ca89ca0/6af66/0zIEH5X.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "77.13004484304933%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'309\\'%20viewBox=\\'0%200%20400%20309\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M110%2012c-2%201-2%202-2%208%200%208%201%209%206%209%205-1%205-3%200-4-3%200-4-3-1-3l3-2-3-2c-3%200-3-3%201-3%201%200%202%200%202-2-1-2-4-2-6-1m113%201l-1%207c0%207%200%207%203%208s5%201%205-1l-2-2-3-1%202-2%202-1-2-2-2-1%202-2c3%200%205-1%205-3h-9m-94%208v8c1%201%203-1%203-3-1-3%201-4%202-1%202%204%203%204%205-1%201-5%203-4%203%201%200%203%201%205%203%203%201-2-1-14-3-15-2%200-4%202-5%206%200%204-1%204-3-1-4-8-6-7-5%203m20-2l-1%207c0%203%202%203%203%200%200-1%201-2%203-2l2%202c1%203%203%202%203-1-1-6-5-12-7-12-1%200-2%201-3%206m113-5v13c1%203%205%202%207%200s3-6%201-6l-1-2c1-4-5-8-7-5m11%203c-1%205%200%2010%204%2011%205%201%206-4%203-11-2-4-5-4-7%200M140%2082v40H90a2218%202218%200%2000-3%201h53v85H88a2369%202369%200%2000-3%201h55v40l1%2041v-81h116v40a861%20861%200%20001-1l1-38%2055-1%2055-1H259v-85h57a627%20627%200%2000-1-2l-56%201V82l-1-39-1%2039v39h-5l-57%201h-53V83l-1-39c-1-1-1%2010-1%2038m1%2083l1%2043h115v-85H141v42m193%2019h-1l-1-1c-2%200-2%202-1%206h2c2%201%203%201%203-1l2%201h3l1-1c0%202%202%203%203%200h1c2%203%203%202%203-2s0-4-1-3c-1%202-2%202-2%201h-5c-2-2-4-1-4%201l-1-1c-1-2-1-2-2%200m-113%2011l1%203%201-1c0-3%202-2%202%200%201%203%203%202%202-2l1-2%201%203%201%203%201-1h8l3-1h3c2%202%203%201%203-2%200-4-2-6-2-2h-1c0-2-2-1-2%201l-1-1h-3c-2%202-2%202-2%200-1-2-1-2-2-1v5l-2-2c0-3-5-5-8-3h-1c-2-2-3-1-3%203m131%200c1%204%202%205%202%202l1-3%201%203%201%202h12c3%200%203%200%203-4%200-2-1-3-2-3v5l-2-2-1-2h-2c-2-1-2-1-2%201h-4l-3-1c-2-2-5-1-4%202M87%20238c0%202%200%202-1%200h-3c-1-1-1-1-1%202%200%204%201%205%202%202h2c1%202%204%202%205%201h2c0%202%204%201%204-1h1c2%203%203%202%203-2l-1-4-1%202c0%202%200%202-1%201-2-3-3-2-3%201v3l-1-3c-1-4-4-4-4-1-1%202-1%202-1%200%200-3-2-4-2-1m241%200v7l1-1%201-2%202%202c2%203%204%202%204-2%200-2%200-2%202%200v2c-2%202%200%202%204%201%203-1%204-1%206%202%201%201%202%202%201%203v1c0%202%203-1%203-3-1-1%200-2%201-3h1l2%201%202-1-1-1-1-2c0-3-2-4-2-1h-1c0-2-3-3-4-1v6l-1-3-1-4-1%202h-1v-1c0-1-2-2-3-1v3l1%201c-2%200-4-2-4-5l-2%201h-5l-4-1m-38%203c0%203%202%206%204%204h5l2-1c1%202%204%201%204-1l1%201c1%202%202%203%204%201l-1-1-1-2c0-2-1-3-2-3-2%200-3%201-2%202l-1%201-1-2c0-2%200-2-1-1h-6c0-2-4-1-5%202m-72%2025c0%202%200%202-1%200%200-2-2-3-2-1%200%205%203%206%204%203l1-2v2l1%202%202-2v-2l1%202c0%202%202%203%204%201h5c1%202%202%201%202-2l-1-2%201%203%202%203v-3l1-3%201%203%202%202%201-2v-3l1%202c0%203%202%204%204%202v-4c-1-2-13-3-13-1h-1c-2-2-3-1-3%201s0%202-1%200l-6-2c-5%200-5%200-5%203m6%207v4c1%203%201%203%202%201l1-2v2l1%202%208-1%207-1h1l3%201c3%200%204-2%202-4v-2c-2-2-4%200-2%202v2l-2-2c0-3%200-3-2-2h-4c0%202%200%202-1%201-2-1-2-1-2%201v3l-1-3-2-2-1%202c0%202%200%202-1%201%200-2-2-3-2-1-1%201-1%200-1-1%200-2-3-3-4-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7cd4edb89f6d04b3df2ac7123ca89ca0/ca0a1/0zIEH5X.webp 223w", "/static/7cd4edb89f6d04b3df2ac7123ca89ca0/75680/0zIEH5X.webp 445w", "/static/7cd4edb89f6d04b3df2ac7123ca89ca0/0ba47/0zIEH5X.webp 640w"],
              "sizes": "(max-width: 640px) 100vw, 640px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7cd4edb89f6d04b3df2ac7123ca89ca0/e92b6/0zIEH5X.png 223w", "/static/7cd4edb89f6d04b3df2ac7123ca89ca0/e66bf/0zIEH5X.png 445w", "/static/7cd4edb89f6d04b3df2ac7123ca89ca0/6af66/0zIEH5X.png 640w"],
              "sizes": "(max-width: 640px) 100vw, 640px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/7cd4edb89f6d04b3df2ac7123ca89ca0/6af66/0zIEH5X.png",
              "alt": "0zIEH5X",
              "title": "0zIEH5X",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Ask for updates and always follow up. When something's done congratulate, when something falls behind ask why.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/cryptosledding/status/1187750296811909121"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.73991031390135%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'183\\'%20viewBox=\\'0%200%20400%20183\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%209c-10%206-9%2021%201%2026%207%204%2014%202%2011-3v-2c2%200%202-1%201-3l-2-5-2-4-1%201c1%201%200%203-1%204-1%203-1%203-3%201v-3c2%201%203-1%202-3-1-1-1-1%201-2l1-1c-3%200%201-4%204-4%205%200%207%208%204%2018-2%206-2%207%201%205%205-4%207-15%203-21S38%205%2031%209m243%2058c-2%201-2%203-2%205s-1%204-4%207c-4%204-5%207-3%207l6-4c2-3%204-4%207-4%206%200%208-6%204-11-3-2-5-3-8%200M67%20124c-4%205-2%2013%203%2011%202%200%202%200%201%201h6v-2c-1-1-1-1%201-3%203-2%203-4-1-7-3-3-7-3-10%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d87c9ffb70cd6fe58effbe5335ec64e3/ca0a1/techletter.app-screenshot-1572027737410.webp 223w", "/static/d87c9ffb70cd6fe58effbe5335ec64e3/75680/techletter.app-screenshot-1572027737410.webp 445w", "/static/d87c9ffb70cd6fe58effbe5335ec64e3/0ba47/techletter.app-screenshot-1572027737410.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d87c9ffb70cd6fe58effbe5335ec64e3/e92b6/techletter.app-screenshot-1572027737410.png 223w", "/static/d87c9ffb70cd6fe58effbe5335ec64e3/e66bf/techletter.app-screenshot-1572027737410.png 445w", "/static/d87c9ffb70cd6fe58effbe5335ec64e3/6af66/techletter.app-screenshot-1572027737410.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d87c9ffb70cd6fe58effbe5335ec64e3/6af66/techletter.app-screenshot-1572027737410.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And remember, a well managed team will out-code you any day of the week.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: I crowdsourced some of the ideas, you can check out `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1187749487873183745"
      }}>{`this thread on twitter`}</a>{` for more wisdom`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      